import call from "./call";
import {
  Skill,
  SkillDetail,
  SkillsResponse,
  SkillPayload,
} from "../Models/skill";

export const getSkills = async (): Promise<Skill[]> => {
  const response = await call.get<SkillsResponse>("/v1/skill/", {
    snack: {
      error: "skill.fetchError",
    },
  });
  return response.data.skills;
};

export const getSingleSkill = async (skillId: number): Promise<SkillDetail> => {
  const response = await call.get<SkillDetail>(`/v1/skill/${skillId}/`, {
    snack: {
      error: "skill.fetchSingleError",
    },
  });
  return response.data;
};

export const createSkill = async (
  data: SkillPayload,
): Promise<SkillDetail> => {
  const response = await call.post<SkillDetail>("/v1/skill/", data, {
    snack: {
      success: "skill.createSuccess",
      error: "skill.createError",
    },
  });
  return response.data;
};

export const updateSkill = async (
  skillId: number,
  data: SkillPayload,
): Promise<SkillDetail> => {
  const response = await call.put<SkillDetail>(`/v1/skill/${skillId}/`, data, {
    snack: {
      success: "skill.updateSuccess",
      error: "skill.updateError",
    },
  });
  return response.data;
};

export const deleteSkill = async (skillId: number): Promise<void> => {
  await call.delete(`/v1/skill/${skillId}/`, {
    snack: {
      success: "skill.deleteSuccess",
      error: "skill.deleteError",
    },
  });
};
